import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, clienteId) {
        state.id = clienteId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_CLIENTE' (state, cliente) {
        state.nombre = cliente.nombre.trim();
        state.inactivo = (/true/i).test(cliente.inactivo);
        state.rowVersion = cliente.rowVersion;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, clienteId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', clienteId);

            if (clienteId != 0) {
                apiAxios.get('clientes/' + clienteId + '/abm' ) 
                    .then(res => {
                        commit('SET_CLIENTE', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let cliente= {
                    nombre: state.nombre.toUpperCase().trim(),
                    inactivo: (/true/i).test(state.inactivo),
                };

                let url = 'clientes';
                if (state.id != 0) {
                    url += '/' + state.id;
                    cliente.rowVersion = state.rowVersion;
                }

                apiAxios.post(url, cliente)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}